import { useState } from 'react'
import Link from 'next/link'
import Svg from 'components/svg/svg'
import Icon from 'components/icon/icon'
import { cn } from 'utils/helpers'
import styles from './bread.module.scss'

export default function Bread({ items, small, checkout, className }) {
    const [minified, setMinified] = useState(true)

    if (!items || !items.length) return ''

    return (
        <ol
            itemScope
            itemType="https://schema.org/BreadcrumbList"
            className={cn(
                styles.bread,
                small && styles.small,
                minified && styles.minified,
                checkout && styles.checkout,
                className
            )}
        >
            {items.map((item, k) =>
                item.url ? (
                    <li key={k} itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
                        <Link href={item.url}>
                            <a
                                itemType="https://schema.org/Thing"
                                itemProp="item"
                                className={cn(item.disabled && styles.disabled, item.active && styles.active)}
                            >
                                <span itemProp="name">{item.name}</span>
                            </a>
                        </Link>
                        <meta itemProp="position" content={k + 1} />
                        {items.length > 2 && !k && minified && (
                            <>
                                <Svg name="right" className={styles.moreRight} />
                                <Icon onClick={() => setMinified(false)} className={styles.more} icon="more" />
                            </>
                        )}
                        {k < items.length - 1 && <Svg name="right" />}
                    </li>
                ) : (
                    <span key={k}>{item.name}</span>
                )
            )}
        </ol>
    )
}
